/**
 * Where a patient-profile link was opened from. Surfaces on the
 * `view_patient_profile_page` analytics event as the `source` property so we
 * can attribute profile views to their entry point.
 */
export enum PatientProfileSource {
  PatientsTable = 'patients_table',
  FollowUps = 'follow_ups',
  Appointments = 'appointments',
  Invoices = 'invoices',
  PrescriptionReview = 'prescription_review',
  Scheduling = 'scheduling',
  BenefitCheck = 'benefit_check',
  InCall = 'in_call',
}

/**
 * Returns the canonical URL for a patient profile in the provider portal.
 *
 * `source` is appended as a `?source=` query param so the profile page can
 * report which entry point the provider came from.
 */
export function getPatientHref(
  healthieId: string,
  source?: PatientProfileSource,
): string {
  return source
    ? `/patients/${healthieId}?source=${source}`
    : `/patients/${healthieId}`;
}
